export default __webpack_public_path__ + "static/media/cement.05aae4a4.mp4";